import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nConfig, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';

import { knbrHomeTranslationChunksConfig, knbrHomeTranslations } from 'src/customer-libs/kn-br-home/assests/translation/translation';
import { KnBrCustomerHeaderComponent } from './kn-br-customer-header.component';

@NgModule({
  declarations: [KnBrCustomerHeaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    NgSelectModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrPurchasingAgentHeaderComponent: {
          component: () => import('./kn-br-customer-header.component').then((c) => c.KnBrCustomerHeaderComponent),
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideConfig(<I18nConfig>{
      i18n: {
        resources: knbrHomeTranslations,
        chunks: knbrHomeTranslationChunksConfig,
      },
    }),
  ],
  exports: [KnBrCustomerHeaderComponent],
})
export class KnBrCustomerHeaderModule { }
